(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(73408);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/useGLTF.js + 3 modules
var useGLTF = __webpack_require__(18626);
// EXTERNAL MODULE: ./node_modules/@react-three/fiber/dist/react-three-fiber.esm.js + 2 modules
var react_three_fiber_esm = __webpack_require__(15029);
// EXTERNAL MODULE: ./src/v2/components/ui/buttons/buttonWithIcon/index.tsx + 3 modules
var buttonWithIcon = __webpack_require__(52787);
// EXTERNAL MODULE: ./src/v2/components/ui/label/index.tsx
var label = __webpack_require__(45306);
// EXTERNAL MODULE: ./src/components/hooks/protocol/vaults/useAllVaultData.ts
var useAllVaultData = __webpack_require__(90160);
// EXTERNAL MODULE: ./src/components/hooks/utils/useIsMobile.ts
var useIsMobile = __webpack_require__(56490);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/components/types.ts
var types = __webpack_require__(87493);
// EXTERNAL MODULE: ./src/components/utils/utils.tsx
var utils = __webpack_require__(63189);
// EXTERNAL MODULE: ./src/v2/components/layout/website/SlideWrapper.tsx
var SlideWrapper = __webpack_require__(47697);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/landing/LandingSlide.tsx
/* eslint-disable react/no-unknown-property */ 












var MODEL_MASK_PATH = "/models/Mecha_Helmet.gltf";
// const VestaMaskModelScene: FC<{ mouseX: number; mouseY: number }> = ({ mouseX, mouseY }) => {
//   const { scene } = useGLTF(MODEL_MASK_PATH);
//   const frontFaceSpot = React.useRef<PointLight>(null!);
//   const modelRef = React.useRef<Object3D>(null!);
//   useThree(({ camera }) => {
//     camera.position.set(-0.2, 0.3, 1);
//     if (modelRef.current) {
//       modelRef.current.lookAt(mouseX / 3500, -mouseY / 3500, 1);
//     }
//   });
//   return (
//     <>
//       <ambientLight />
//       <spotLight color={[0.75, 0.5, 0.8]} intensity={10} position={[0, 10, 45]} />
//       <pointLight ref={frontFaceSpot} color={[0.75, 1, 1]} intensity={10} position={[-2, 3.5, 3.5]} />
//       <primitive ref={modelRef} object={scene} />
//     </>
//   );
// };
useGLTF/* useGLTF.preload */.L.preload(MODEL_MASK_PATH);
function LandingSlide() {
    var ref = (0,useAllVaultData/* useAllVaultData */.V)(), _computed = ref.computed, totalCollateralUsd = _computed.totalCollateralUsd, totalSystemDebtVst = _computed.totalSystemDebtVst;
    // const [mouseX, setMouseX] = useState<number>(0);
    // const [mouseY, setMouseY] = useState<number>(0);
    var isMobile = (0,useIsMobile/* useIsMobile */.d)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        onMouseMove: function(e) {
        // setMouseX(e.clientX - window.innerWidth / 0.8);
        // setMouseY(e.clientY - window.innerHeight / 1.3);
        },
        sx: {
            justifyContent: "center",
            overflow: "hidden"
        },
        children: [
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    position: "absolute",
                    top: 16,
                    right: 0,
                    width: 800,
                    height: {
                        xs: 1080,
                        md: 1200
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_three_fiber_esm/* Canvas */.Xz, {})
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                mt: 28,
                justifyContent: {
                    xs: "center",
                    sm: "start"
                },
                textAlign: {
                    xs: "center",
                    sm: "left"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h2",
                                children: "Uncensorable, yield generating stablecoin"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                mt: 4,
                                mb: 8,
                                color: colors/* primaryColors.400 */.w2[400],
                                children: "Vesta Stable (VST) is a non-biased, non-censorable stablecoin that can be generated against crypto asset and used anywhere, anytime."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: {
                                    xs: "column",
                                    sm: "row"
                                },
                                textAlign: {
                                    xs: "center",
                                    sm: "left"
                                },
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        sx: {
                                            width: {
                                                xs: "100%",
                                                sm: 300
                                            }
                                        },
                                        variant: "primary",
                                        iconType: "arrow",
                                        children: [
                                            " ",
                                            "ENTER THE APPLICATION"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        variant: "secondary",
                                        sx: {
                                            width: {
                                                xs: "100%",
                                                sm: 300
                                            }
                                        },
                                        children: [
                                            " ",
                                            "HOW IT WORKS",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: {
                            xs: 32,
                            md: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                variant: "vertical",
                                labelTitleVariant: "h6",
                                labelTitle: "Total Value Locked",
                                labelValueVariant: "h2",
                                labelValue: (0,utils/* displayFormatUnits */.Hz)({
                                    value: totalCollateralUsd,
                                    displayType: types/* EDisplayType.USD */.co.USD
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: {
                                    xs: "column",
                                    sm: "row"
                                },
                                spacing: {
                                    xs: 4,
                                    sm: 0
                                },
                                mt: 8,
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                        variant: "vertical",
                                        labelTitleVariant: "h6",
                                        labelTitle: "Total Volume of VST Traded",
                                        labelValueVariant: "h4",
                                        labelValue: (0,utils/* displayFormatUnits */.Hz)({
                                            value: 1000000,
                                            displayType: types/* EDisplayType.USD */.co.USD
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                        variant: "vertical",
                                        labelTitleVariant: "h6",
                                        labelTitle: "Total VST Circulating",
                                        labelValueVariant: "h4",
                                        labelValue: (0,utils/* displayFormatUnits */.Hz)({
                                            value: totalSystemDebtVst,
                                            displayType: types/* EDisplayType.VST */.co.VST
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                        variant: "vertical",
                                        labelTitleVariant: "h6",
                                        labelTitle: "Vaults Opened",
                                        labelValueVariant: "h4",
                                        labelValue: 42069
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var landing_LandingSlide = (LandingSlide);

// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 4 modules
var Tooltip = __webpack_require__(4615);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/ArrowSquareOut.esm.js
var ArrowSquareOut_esm = __webpack_require__(92777);
// EXTERNAL MODULE: ./src/v2/components/ui/icons/vesta/index.tsx
var vesta = __webpack_require__(77435);
// EXTERNAL MODULE: ./src/components/shared/link/index.tsx
var shared_link = __webpack_require__(67113);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/landing/PartnerWeaveSlide.tsx









var MobileFadingContainer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1240).then(__webpack_require__.bind(__webpack_require__, 51240)).then(function(param) {
        var MobileFadingContainer = param.MobileFadingContainer;
        return MobileFadingContainer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51240)
            ];
        }
    },
    ssr: false
});
var PartnerLatticeNode = function(param) {
    var icon = param.icon, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 36 : _iconSize, toolTipTitle = param.toolTipTitle, linkLabel = param.linkLabel, href = param.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        placement: "bottom",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 1,
            mt: 0.5,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "label3",
                    color: colors/* primaryColors.700 */.w2[700],
                    children: toolTipTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* NormalLink */.Yk, {
                    href: href,
                    target: "_blank",
                    sx: {
                        textDecoration: "none"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "label3",
                                children: linkLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ml: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowSquareOut_esm/* default */.Z, {
                                    size: 14,
                                    weight: "bold"
                                })
                            })
                        ]
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vesta/* VestaIcon */.QA, {
                sx: {
                    boxShadow: "2px 1px 10px ".concat(colors/* black.45% */.Sn["45%"]),
                    transition: "border-color 0.15s linear",
                    ": hover": {
                        borderColor: colors/* primaryColors.50 */.w2[50]
                    }
                },
                round: true,
                icon: icon,
                size: iconSize,
                containerPadding: 36
            })
        })
    });
};
var PartnerWeaveSlide = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        color: colors/* primaryColors.50 */.w2[50],
                        children: "Weaving Layer-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        color: colors/* primaryColors.400 */.w2[400],
                        children: "VST is collateralized by a variety of collaterals. All collaterals onboarded go through a rigorous onboarding process and the respective risks are continuously monitored."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFadingContainer, {
                app: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    px: "160px",
                    spacing: 8,
                    mt: 14,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            alignItems: "center",
                            px: "120px",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.OHM */.LK.OHM,
                                    linkLabel: "OLYMPUS DAO",
                                    toolTipTitle: "DEEP INTEGRATION",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    iconSize: 56,
                                    icon: vesta/* VestaNetworkIcons.ARBITRUM */.Tb.ARBITRUM,
                                    linkLabel: "ARBITRUM",
                                    toolTipTitle: "ECOSYSTEM",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.GMX */.LK.GMX,
                                    linkLabel: "GMX",
                                    toolTipTitle: "DEEP INTEGRATION",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.OPENOCEAN */.LK.OPENOCEAN,
                                    linkLabel: "OPENOCEAN",
                                    toolTipTitle: "SWAP & TRADE",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.ONEINCH */.LK.ONEINCH,
                                    linkLabel: "1INCH",
                                    toolTipTitle: "SWAP & TRADE",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.BAL */.LK.BAL,
                                    linkLabel: "BALANCER",
                                    toolTipTitle: "SWAP & TRADE",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.CURVE */.LK.CURVE,
                                    linkLabel: "CURVE",
                                    toolTipTitle: "LIQUIDITY",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            px: "120px",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.REDACTED */.LK.REDACTED,
                                    linkLabel: "REDACTED CARTEL",
                                    toolTipTitle: "LIQUIDITY",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.AURA */.LK.AURA,
                                    linkLabel: "AURA",
                                    toolTipTitle: "LIQUIDITY",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.BPROTOCOL */.LK.BPROTOCOL,
                                    linkLabel: "B.PROTOCOL",
                                    toolTipTitle: "LIQUIDITY",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.RISKDAO */.LK.RISKDAO,
                                    linkLabel: "RISK DAO",
                                    toolTipTitle: "SECURITY",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.SYNAPSE */.LK.SYNAPSE,
                                    linkLabel: "SYNAPSE",
                                    toolTipTitle: "BRIDGING",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.LIFI */.LK.LIFI,
                                    linkLabel: "LI.FI",
                                    toolTipTitle: "BRIDGING",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.VERILOG */.LK.VERILOG,
                                    linkLabel: "VERILOG",
                                    toolTipTitle: "SECURITY",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                icon: vesta/* VestaPartnerIcons.CREDPROTOCOL */.LK.CREDPROTOCOL,
                                linkLabel: "CRED PROTOCOL",
                                toolTipTitle: "SECURITY",
                                href: ""
                            })
                        })
                    ]
                }),
                mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    px: "160px",
                    spacing: 8,
                    mt: 14,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                iconSize: 56,
                                icon: vesta/* VestaNetworkIcons.ARBITRUM */.Tb.ARBITRUM,
                                linkLabel: "ARBITRUM",
                                toolTipTitle: "ECOSYSTEM",
                                href: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.ONEINCH */.LK.ONEINCH,
                                    linkLabel: "1INCH",
                                    toolTipTitle: "SWAP & TRADE",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.BAL */.LK.BAL,
                                    linkLabel: "BALANCER",
                                    toolTipTitle: "SWAP & TRADE",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                icon: vesta/* VestaPartnerIcons.AURA */.LK.AURA,
                                linkLabel: "AURA",
                                toolTipTitle: "LIQUIDITY",
                                href: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.SYNAPSE */.LK.SYNAPSE,
                                    linkLabel: "SYNAPSE",
                                    toolTipTitle: "BRIDGING",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.LIFI */.LK.LIFI,
                                    linkLabel: "LI.FI",
                                    toolTipTitle: "BRIDGING",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                icon: vesta/* VestaPartnerIcons.CURVE */.LK.CURVE,
                                linkLabel: "CURVE",
                                toolTipTitle: "LIQUIDITY",
                                href: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.RISKDAO */.LK.RISKDAO,
                                    linkLabel: "RISK DAO",
                                    toolTipTitle: "SECURITY",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.VERILOG */.LK.VERILOG,
                                    linkLabel: "VERILOG",
                                    toolTipTitle: "SECURITY",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                icon: vesta/* VestaPartnerIcons.CREDPROTOCOL */.LK.CREDPROTOCOL,
                                linkLabel: "CRED PROTOCOL",
                                toolTipTitle: "SECURITY",
                                href: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.OHM */.LK.OHM,
                                    linkLabel: "OLYMPUS DAO",
                                    toolTipTitle: "DEEP INTEGRATION",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.GMX */.LK.GMX,
                                    linkLabel: "GMX",
                                    toolTipTitle: "DEEP INTEGRATION",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                icon: vesta/* VestaPartnerIcons.OPENOCEAN */.LK.OPENOCEAN,
                                linkLabel: "OPENOCEAN",
                                toolTipTitle: "SWAP & TRADE",
                                href: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.REDACTED */.LK.REDACTED,
                                    linkLabel: "REDACTED CARTEL",
                                    toolTipTitle: "LIQUIDITY",
                                    href: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLatticeNode, {
                                    icon: vesta/* VestaPartnerIcons.BPROTOCOL */.LK.BPROTOCOL,
                                    linkLabel: "B.PROTOCOL",
                                    toolTipTitle: "LIQUIDITY",
                                    href: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: "142px",
                            width: "100%",
                            justifyContent: "center"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var landing_PartnerWeaveSlide = (PartnerWeaveSlide);

// EXTERNAL MODULE: ./src/v2/components/ui/images/index.tsx + 1 modules
var ui_images = __webpack_require__(24639);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/landing/SecurePartnerSlide.tsx







var RISK_DAO_BG = "linear-gradient(278.18deg, rgba(124, 79, 219, 0.8) -7.61%, rgba(0, 251, 234, 0.5) 39.1%, #B5EDFF 83.03%), #FFFFFF";
function SecurePartnersSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper/* default */.Z, {
        sx: {
            background: RISK_DAO_BG,
            textAlign: "center",
            justifyContent: "space-around",
            py: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            sx: {
                alignItems: "center",
                justifyContent: "center"
            },
            spacing: 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    color: colors/* primaryColors.900 */.w2[900],
                    children: "Secured by professional risk managers"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* RiskDAOLogoV2 */.MI, {
                    background: "black"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: {
                        xs: "column",
                        md: "row"
                    },
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                            iconType: "asterisk",
                            sx: {
                                color: "black",
                                borderColor: "black",
                                width: 320
                            },
                            variant: "secondary",
                            children: "COLLATERAL PARAMETER ANALYSIS"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                            iconType: "asterisk",
                            sx: {
                                color: "black",
                                borderColor: "black",
                                width: 320
                            },
                            variant: "secondary",
                            children: "RISK DAO VESTA DASHBOARD"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: {
                        xs: "column",
                        md: "row"
                    },
                    spacing: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    color: colors/* primaryColors.900 */.w2[900],
                                    children: "Audited by"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* VerilogLogoV2 */.H2, {
                                    background: colors/* primaryColors.900 */.w2[900]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    color: colors/* primaryColors.900 */.w2[900],
                                    children: "Secured by"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* ImmuneFiLogoV2 */.k$, {
                                    background: colors/* primaryColors.900 */.w2[900]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var SecurePartnerSlide = (SecurePartnersSlide);

// EXTERNAL MODULE: ./src/v2/components/layout/website/roadmap/panel/index.tsx
var panel = __webpack_require__(65242);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/landing/ShortRoadmapSlide.tsx








var ShortRoadmapSlide_MobileFadingContainer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1240).then(__webpack_require__.bind(__webpack_require__, 51240)).then(function(param) {
        var MobileFadingContainer = param.MobileFadingContainer;
        return MobileFadingContainer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51240)
            ];
        }
    },
    ssr: false
});
function ShortRoadmapSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        color: colors/* primaryColors.50 */.w2[50],
                        children: "Roadmap"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        color: colors/* primaryColors.400 */.w2[400],
                        children: "VST is collateralized by a variety of collaterals. All collaterals onboarded go through a rigorous onboarding process and the respective risks are continuously monitored."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortRoadmapSlide_MobileFadingContainer, {
                app: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    direction: "row",
                    spacing: 8,
                    mt: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* RoadmapPanel */.wC, {
                                quarterText: "Q4 2022",
                                quarterDescription: "Vesta Trader: an internally-used DEX aggregator, was created"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* RoadmapPanel */.wC, {
                                quarterText: "Q1 2023",
                                quarterDescription: "VST Saving Module, VSTA Staking Module",
                                current: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* RoadmapPanel */.wC, {
                                quarterText: "Q2 2023",
                                quarterDescription: "Further expansion of VST use cases, making VST the go-to stable on Arbitrum"
                            })
                        })
                    ]
                }),
                mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    direction: "row",
                    spacing: 8,
                    mt: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* VerticalRoadmapPanel */.Pt, {
                                stepTitle: "Q4 2022",
                                subtitleVariant: "body2",
                                subtitle: "Vesta Trader: an internally-used DEX aggregator, was created",
                                highlight: "completed"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* VerticalRoadmapPanel */.Pt, {
                                stepTitle: "Q1 2023",
                                subtitleVariant: "body2",
                                subtitle: "VST Saving Module, VSTA Staking Module",
                                highlight: "current"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* VerticalRoadmapPanel */.Pt, {
                                stepTitle: "Q2 2023",
                                highlight: "upcoming",
                                subtitleVariant: "body2",
                                subtitle: "Further expansion of VST use cases, making VST the go-to stable on Arbitrum"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                iconType: "asterisk",
                sx: {
                    width: 280,
                    mt: 8
                },
                children: "CHECK OUT OUR FULL ROADMAP"
            })
        ]
    });
}
/* harmony default export */ var landing_ShortRoadmapSlide = (ShortRoadmapSlide);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/CaretDown.esm.js
var CaretDown_esm = __webpack_require__(10622);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/CaretUp.esm.js
var CaretUp_esm = __webpack_require__(48509);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMeasure.js + 1 modules
var useMeasure = __webpack_require__(33047);
;// CONCATENATED MODULE: ./src/v2/components/ui/containers/collapse/index.tsx







var CaretCollapse = function(param) {
    var collapsed = param.collapsed, size = param.size;
    return collapsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretDown_esm/* default */.Z, {
        size: size
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretUp_esm/* default */.Z, {
        size: size
    });
};
var CollapsableContainer = function(param) {
    var _caretPlacement = param.caretPlacement, caretPlacement = _caretPlacement === void 0 ? "right" : _caretPlacement, hideCaret = param.hideCaret, collapsed = param.collapsed, title = param.title, titleSx = param.titleSx, _caretSize = param.caretSize, caretSize = _caretSize === void 0 ? 24 : _caretSize, _titleVariant = param.titleVariant, titleVariant = _titleVariant === void 0 ? "h4" : _titleVariant, children = param.children, titleContainerSx = param.titleContainerSx, contentContainerSx = param.contentContainerSx, onCollapse = param.onCollapse;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMeasure/* default */.Z)(), 2), ref1 = ref[0], height = ref[1].height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: (0,_object_spread/* default */.Z)({
                    zIndex: 2,
                    cursor: "pointer"
                }, titleContainerSx),
                onClick: onCollapse,
                children: [
                    caretPlacement === "left" && !hideCaret ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretCollapse, {
                        size: caretSize,
                        collapsed: collapsed
                    }) : null,
                    typeof title === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: (0,_object_spread/* default */.Z)({
                            transition: "color 0.15s linear",
                            userSelect: "none"
                        }, titleSx),
                        variant: titleVariant,
                        color: collapsed ? colors/* primaryColors.700 */.w2[700] : colors/* primaryColors.100 */.w2[100],
                        children: title
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: titleSx,
                        children: title
                    }),
                    caretPlacement === "right" && !hideCaret ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretCollapse, {
                        size: caretSize,
                        collapsed: collapsed
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: (0,_object_spread/* default */.Z)({
                    transition: "height 0.2s ease-out",
                    height: collapsed ? 0 : height,
                    overflowY: "hidden"
                }, contentContainerSx),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    ref: ref1,
                    sx: {
                        minHeight: height
                    },
                    children: children
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/shared/divider/index.tsx
var divider = __webpack_require__(38359);
// EXTERNAL MODULE: ./src/components/theme/styles/mixins.tsx
var mixins = __webpack_require__(52230);
// EXTERNAL MODULE: ./src/components/theme/typography.ts
var typography = __webpack_require__(62157);
// EXTERNAL MODULE: ./src/config/types.ts
var config_types = __webpack_require__(87859);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/landing/StableCoinSlide.tsx


















var StableCoinSlide_MobileFadingContainer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1240).then(__webpack_require__.bind(__webpack_require__, 51240)).then(function(param) {
        var MobileFadingContainer = param.MobileFadingContainer;
        return MobileFadingContainer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51240)
            ];
        }
    },
    ssr: false
});
var CollapseSectionMobile = function() {
    var collapse = function collapse(section) {
        if (sectionView === section) setSectionView(1);
        else setSectionView(section);
    };
    var ref = (0,react.useState)(1), sectionView = ref[0], setSectionView = ref[1];
    var ref1 = (0,useAllVaultData/* useAllVaultData */.V)(), _computed = ref1.computed, totalCollateralUsd = _computed.totalCollateralUsd, totalSystemDebtVst = _computed.totalSystemDebtVst;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        container: true,
        spacing: 4,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                textAlign: "center",
                mb: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* Wormhole */.Df, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsableContainer, {
                            collapsed: sectionView !== 1,
                            title: "Secure and reliable by default",
                            onCollapse: function() {
                                return collapse(1);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 4,
                                py: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body1",
                                        children: [
                                            (0,utils/* displayFormatUnits */.Hz)({
                                                value: totalSystemDebtVst,
                                                displayType: types/* EDisplayType.Token */.co.Token
                                            }),
                                            " of minted VST is overcollateralized by",
                                            " ",
                                            (0,utils/* displayFormatUnits */.Hz)({
                                                value: totalCollateralUsd,
                                                displayType: types/* EDisplayType.USD */.co.USD
                                            }),
                                            " of collateral deposited in our vaults."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "All collaterals are rated and constantly monitored."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* NormalDivider */.k4, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsableContainer, {
                            collapsed: sectionView !== 2,
                            title: "Unbiased and Uncensorable",
                            onCollapse: function() {
                                return collapse(2);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 4,
                                py: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body1",
                                        children: "VST can be freely borrowed, traded, and invested on a wide panel of platforms and apps, with no blacklisting or censorship."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                                sx: {
                                                    width: 230
                                                },
                                                iconType: "asterisk",
                                                children: "BUY VST ON CURVE"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                                sx: {
                                                    width: 230
                                                },
                                                iconType: "asterisk",
                                                children: "OUR PARTNERS"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* NormalDivider */.k4, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsableContainer, {
                            collapsed: sectionView !== 3,
                            title: "Innovation-Driven",
                            onCollapse: function() {
                                return collapse(3);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 4,
                                py: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body1",
                                        children: "Protected by the Vesta Reference Rate, secured by the Stability Pools and safeguarded by the Saving Module."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        sx: {
                                            width: 300
                                        },
                                        iconType: "asterisk",
                                        children: "LEARN MORE ABOUT THE FEATURES"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var SimplePanel = function(param) {
    var img = param.img, title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mixins/* secondaryBox */.J0), {
            height: "100%"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: 120,
                    height: 120,
                    children: img
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    sx: {
                        background: colors/* vestaAltGradient */.u_,
                        backgroundClip: "text",
                        WebkitTextFillColor: "transparent"
                    },
                    children: title
                }),
                children
            ]
        })
    });
};
var PanelSectionApp = function() {
    var allVaults = (0,useAllVaultData/* useAllVaultData */.V)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimplePanel, {
                    img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* Wormhole */.Df, {}),
                    title: "Modern & Innovation-Driven",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            color: colors/* primaryColors.100 */.w2[100],
                            children: "Protected by the Vesta Reference Rate, secured by the Stability Pools and safeguarded by the Saving Module."
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimplePanel, {
                    img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* Wormhole */.Df, {}),
                    title: "Secure and reliable by default",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            color: colors/* primaryColors.100 */.w2[100],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "span",
                                    variant: "body2",
                                    sx: (0,typography/* getGradientTypographySx */.De)(colors/* vestaGradient */.pK),
                                    children: (0,utils/* displayFormatUnits */.Hz)({
                                        value: allVaults.computed.totalSystemDebtVst,
                                        displayType: types/* EDisplayType.Token */.co.Token
                                    })
                                }),
                                " ",
                                "of minted VST is overcollateralized by",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "span",
                                    variant: "body2",
                                    sx: (0,typography/* getGradientTypographySx */.De)(colors/* vestaGradient */.pK),
                                    children: (0,utils/* displayFormatUnits */.Hz)({
                                        value: allVaults.computed.totalCollateralUsd,
                                        displayType: types/* EDisplayType.USD */.co.USD
                                    })
                                }),
                                " ",
                                "of collateral deposited in our vaults. All collaterals are rated and constantly monitored."
                            ]
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimplePanel, {
                    img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* Wormhole */.Df, {}),
                    title: "Unbiased and Uncensorable",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            color: colors/* primaryColors.100 */.w2[100],
                            children: "VST can be freely borrowed, traded, and invested on a wide panel of platforms and apps, with no blacklisting or censorship."
                        }),
                        " "
                    ]
                })
            })
        ]
    });
};
var StableCoinSlide = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        position: "relative",
                        item: true,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                position: "absolute",
                                width: "100%",
                                height: "40%",
                                bottom: -30,
                                right: -30,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* PerspectiveGridFull */.wg, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "flex",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* NativeTokenOrbital */.nY, {
                                    asset: config_types/* ENativeAsset.VST */.tx.VST
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            spacing: 2,
                            justifyContent: "center",
                            textAlign: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h4",
                                    color: colors/* primaryColors.400 */.w2[400],
                                    children: "The Gateway to"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    color: colors/* primaryColors.100 */.w2[100],
                                    children: "Vesta Stablecoin"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    color: colors/* primaryColors.400 */.w2[400],
                                    children: "Experience Unparalleled Security & Censorship-Resistance with our overcollateralized stablecoin: VST."
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 18,
                mt: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StableCoinSlide_MobileFadingContainer, {
                            app: /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelSectionApp, {}),
                            mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseSectionMobile, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        textAlign: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "secondary",
                            sx: {
                                width: 310
                            },
                            children: "LEARN MORE ABOUT VST FEATURES"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: {
                                xs: "column",
                                sm: "row"
                            },
                            justifyContent: "space-between",
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        background: colors/* vestaGradient */.pK,
                                        backgroundClip: "text",
                                        WebkitTextFillColor: "transparent"
                                    },
                                    variant: "h5",
                                    children: "Freely borrow and use VST anywhere, anytime"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        borderLeft: {
                                            xs: undefined,
                                            sm: "1px ".concat(colors/* white.15% */.ix["15%"], " solid")
                                        },
                                        borderBottom: {
                                            xs: "1px ".concat(colors/* white.15% */.ix["15%"], " solid"),
                                            sm: undefined
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        textAlign: {
                                            xs: "left",
                                            sm: "right"
                                        },
                                        background: colors/* vestaGradient */.pK,
                                        backgroundClip: "text",
                                        WebkitTextFillColor: "transparent"
                                    },
                                    variant: "h5",
                                    children: "No blacklisting, transferrable all across Arbitrum"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var landing_StableCoinSlide = (StableCoinSlide);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/landing/StayUpdatedSlide.tsx









var ArticlePreview = function(param) {
    var title = param.title, imgSrc = param.imgSrc, description = param.description, href = param.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            borderRadius: "8px",
            width: "100%",
            height: "100%",
            background: colors/* black.45% */.Sn["45%"]
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: 200,
                    width: 240,
                    src: imgSrc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 4,
                direction: "column",
                minHeight: 300,
                p: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "lead",
                        height: 48,
                        color: colors/* primaryColors.100 */.w2[100],
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        height: 78,
                        variant: "body2",
                        color: colors/* primaryColors.100 */.w2[100],
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* NormalLink */.Yk, {
                        href: href,
                        target: "_blank",
                        sx: {
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                            variant: "primary",
                            iconType: "arrow",
                            children: "READ MORE"
                        })
                    })
                ]
            })
        ]
    });
};
var ARTICLES = [
    {
        title: "Florida man buys all VST",
        imgSrc: "/img/carousel/carousel-vote.webp",
        description: "Florida man single handedly restores VST peg, in a bath salts fueled crypto frenzy.",
        href: ""
    },
    {
        title: "Florida man buys all VSTA",
        imgSrc: "/img/carousel/carousel-stake.webp",
        description: "Florida man single handedly becomes the richest man alive in a PCP fueled spending spree.",
        href: ""
    },
    {
        title: "Florida man dies instantly.",
        imgSrc: "/img/carousel/carousel-farm.webp",
        description: "RIP florida man.",
        href: ""
    }, 
];
function StayUpdatedSlide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h4",
                color: colors/* primaryColors.50 */.w2[50],
                children: "Stay up to date with Vesta"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 4,
                mt: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h6",
                        color: colors/* primaryColors.100 */.w2[100],
                        children: "Our latest articles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        direction: "row",
                        children: ARTICLES.map(function(article, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: index >= ARTICLES.length - 1 ? undefined : {
                                    pr: {
                                        xs: 0,
                                        sm: 4
                                    },
                                    pb: {
                                        xs: 4,
                                        sm: 0
                                    }
                                },
                                item: true,
                                xs: 12,
                                sm: 12 / ARTICLES.length,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePreview, (0,_object_spread/* default */.Z)({}, article))
                            }, article.title);
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var landing_StayUpdatedSlide = (StayUpdatedSlide);

// EXTERNAL MODULE: ./src/v2/components/layout/website/landing/SupportedBySlide.tsx
var SupportedBySlide = __webpack_require__(83034);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(48739);
;// CONCATENATED MODULE: ./src/v2/components/layout/website/landing/VestaEmpireSlide.tsx











var VestaEmpireSlide_MobileFadingContainer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1240).then(__webpack_require__.bind(__webpack_require__, 51240)).then(function(param) {
        var MobileFadingContainer = param.MobileFadingContainer;
        return MobileFadingContainer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51240)
            ];
        }
    },
    ssr: false
});
var GatewaySection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 4,
        textAlign: {
            xs: "center",
            sm: "left"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                color: colors/* primaryColors.400 */.w2[400],
                children: "The Gateway to"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h2",
                color: colors/* primaryColors.100 */.w2[100],
                children: "Vesta Empire"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                color: colors/* primaryColors.400 */.w2[400],
                children: "Experience Unparalleled Security & Censorship-Resistance with our overcollateralized stablecoin: VST."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "secondary",
                    sx: {
                        width: 310
                    },
                    children: "LEARN MORE ABOUT YOUR MOM :D"
                })
            })
        ]
    });
};
var VestaEmpireSlide = function() {
    var isMobile = (0,useIsMobile/* useIsMobile */.d)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideWrapper/* default */.Z, {
        sx: {
            overflowX: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VestaEmpireSlide_MobileFadingContainer, {
                app: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                position: "relative",
                                left: 316,
                                bottom: 20
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* AestheticWaves */.mh, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            mb: 12,
                            mt: "-".concat(515 / 2 + 515 / 4 + 515 / 8, "px"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 5,
                                    height: "400px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        pl: {
                                            sm: 12,
                                            md: 18
                                        },
                                        pt: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* NativeTokenOrbital */.nY, {
                                            asset: config_types/* ENativeAsset.VSTA */.tx.VSTA
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 7,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GatewaySection, {})
                                })
                            ]
                        })
                    ]
                }),
                mobile: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    alignItems: "center",
                    spacing: 20,
                    pt: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_images/* NativeTokenOrbital */.nY, {
                            asset: config_types/* ENativeAsset.VSTA */.tx.VSTA
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GatewaySection, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                justifyContent: "space-between",
                mt: 12,
                direction: {
                    xs: "column",
                    sm: "row"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 4,
                        sx: isMobile ? {
                            borderBottom: "1px solid ".concat(colors/* secondaryColors.200 */.St[200]),
                            pb: 4
                        } : {
                            borderRight: "1px solid ".concat(colors/* secondaryColors.200 */.St[200]),
                            pr: "64px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h4",
                                color: colors/* primaryColors.50 */.w2[50],
                                children: "Staking"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body1",
                                color: colors/* primaryColors.400 */.w2[400],
                                children: "Unlock the full potential of your VSTA by staking them in the Vesta Staking Module."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: {
                                    xs: "column",
                                    sm: "row"
                                },
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        iconType: "asterisk",
                                        sx: {
                                            width: 170
                                        },
                                        children: "START STAKING"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        iconType: "asterisk",
                                        sx: {
                                            width: 150
                                        },
                                        children: "LEARN MORE"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        sx: isMobile ? {
                            pt: 4
                        } : {
                            pl: "64px"
                        },
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h4",
                                color: colors/* primaryColors.50 */.w2[50],
                                children: "Governance"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body1",
                                color: colors/* primaryColors.400 */.w2[400],
                                children: "Your ticket to active participation in shaping the protocol through governance."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: {
                                    xs: "column",
                                    sm: "row"
                                },
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        iconType: "asterisk",
                                        sx: {
                                            minWidth: 300,
                                            width: 300
                                        },
                                        children: "VISIT CURIA - GOVERNANCE FORUM"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                                        iconType: "asterisk",
                                        sx: {
                                            width: 180
                                        },
                                        children: "VISIT SNAPSHOT"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var landing_VestaEmpireSlide = (VestaEmpireSlide);

// EXTERNAL MODULE: ./src/v2/components/layout/website/LandingEngagement.tsx
var LandingEngagement = __webpack_require__(14825);
// EXTERNAL MODULE: ./src/v2/components/layout/website/LandingFooter.tsx
var LandingFooter = __webpack_require__(28424);
// EXTERNAL MODULE: ./src/v2/components/ui/containers/fade/index.tsx
var fade = __webpack_require__(41394);
;// CONCATENATED MODULE: ./src/pages/index.tsx














var HomePage = function() {
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setVisible(true);
        }, 1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(fade/* FadeContainer */.B, {
                visible: visible ? 1 : 0,
                time: 0.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_LandingSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurePartnerSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_StableCoinSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_VestaEmpireSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PartnerWeaveSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportedBySlide/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_ShortRoadmapSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_StayUpdatedSlide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingEngagement/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 83034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83321);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27842);
/* harmony import */ var _components_shared_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67113);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16381);
/* harmony import */ var _SlideWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47697);







var VIP_SHILL_LIST = [
    {
        person: "TETRANODE",
        href: ""
    },
    {
        person: "DCFGOD",
        href: ""
    },
    {
        person: "FISKANTES",
        href: ""
    },
    {
        person: "NOT3LAU CAPITAL",
        href: ""
    },
    {
        person: "SAM KAZEMIAN@FRAX",
        href: ""
    },
    {
        person: "OXMONS@SUDOSWAP",
        href: ""
    },
    {
        person: "MARIANO CONTI",
        href: ""
    },
    {
        person: "FISHERS CAPITAL",
        href: ""
    },
    {
        person: "ANGELDAO",
        href: ""
    }, 
];
var SupportedBySlide = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SlideWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                spacing: 8,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h4",
                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[50] */ .w2[50],
                        children: "Supported by the best"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[400] */ .w2[400],
                        children: "Not to namedrop but, some heavy players are around"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                container: true,
                direction: "row",
                justifyContent: "space-between",
                spacing: 4,
                mt: 8,
                children: VIP_SHILL_LIST.map(function(param) {
                    var person = param.person, href = param.href;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_2__/* .NormalLink */ .Yk, {
                            sx: {
                                textDecoration: "none"
                            },
                            href: href,
                            target: "_blank",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "primary",
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "center",
                                    textAlign: "start",
                                    width: "100%",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            size: 16,
                                            color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[400] */ .w2[400]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            variant: "label2",
                                            sx: {
                                                background: "linear-gradient(278.18deg, rgba(124, 79, 219, 0.8) -7.61%, rgba(0, 251, 234, 0.5) 39.1%, #B5EDFF 83.03%), #FFFFFF",
                                                backgroundClip: "text",
                                                WebkitTextFillColor: "transparent"
                                            },
                                            children: person
                                        })
                                    ]
                                })
                            })
                        })
                    }, person);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "body1",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[400] */ .w2[400],
                mt: 8,
                children: "And more..."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SupportedBySlide);


/***/ }),

/***/ 65242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pt": function() { return /* binding */ VerticalRoadmapPanel; },
/* harmony export */   "sC": function() { return /* binding */ ProcessPanel; },
/* harmony export */   "wC": function() { return /* binding */ RoadmapPanel; }
/* harmony export */ });
/* unused harmony export HorizontalRoadmapStep */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16381);




var HorizontalRoadmapStep = function(param) {
    var current = param.current;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        spacing: 2,
        direction: "row",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: {
                    background: current ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK : _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[900] */ .w2[900],
                    borderRadius: "64px",
                    minWidth: 16,
                    width: 16,
                    height: 16
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: {
                    background: current ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK : _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[900] */ .w2[900],
                    height: 4,
                    width: "100%",
                    borderRadius: "8px"
                }
            })
        ]
    });
};
var HighlightablePanel = function(param) {
    var panelTitle = param.panelTitle, children = param.children, highlight = param.highlight;
    var decorationColor = function decorationColor() {
        switch(highlight){
            case "completed":
                return [
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[700] */ .w2[700],
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[700] */ .w2[700]
                ];
            case "current":
                return [
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK,
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK
                ];
            case "upcoming":
                return [
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .vestaGradient */ .pK,
                    _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[700] */ .w2[700]
                ];
        }
    };
    var decorationBg = decorationColor();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        direction: "column",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                alignItems: "center",
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            background: decorationBg[0],
                            borderRadius: "64px",
                            minWidth: 16,
                            width: 16,
                            height: 16
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "label2",
                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400],
                        children: panelTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                pl: 0.75,
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            background: decorationBg[1],
                            minWidth: 4,
                            maxWidth: 4,
                            width: "100%",
                            borderRadius: "8px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        spacing: 2,
                        children: children
                    })
                ]
            })
        ]
    });
};
var VerticalRoadmapPanel = function(param) {
    var stepTitle = param.stepTitle, subtitle = param.subtitle, subtitleVariant = param.subtitleVariant, children = param.children, highlight = param.highlight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HighlightablePanel, {
        highlight: highlight,
        panelTitle: stepTitle,
        children: [
            subtitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: subtitleVariant ? subtitleVariant : "h4",
                children: subtitle
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                width: {
                    xs: "100%",
                    sm: "60%"
                },
                variant: "body1",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400],
                children: children
            })
        ]
    });
};
var ProcessPanel = function(param) {
    var stepTitle = param.stepTitle, description = param.description, duration = param.duration, children = param.children, highlight = param.highlight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HighlightablePanel, {
        highlight: highlight,
        panelTitle: stepTitle,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "h6",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "body2",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400],
                children: [
                    " ",
                    "Duration: ",
                    typeof duration === "string" ? duration : "~".concat(duration, " days")
                ]
            }),
            children
        ]
    });
};
var RoadmapPanel = function(param) {
    var current = param.current, quarterDescription = param.quarterDescription, quarterText = param.quarterText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HorizontalRoadmapStep, {
                current: current
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "label1",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[400] */ .w2[400],
                children: quarterText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "body2",
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .primaryColors[100] */ .w2[100],
                children: quarterDescription
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3737,9595,6731,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);